/*
 * Loyalty card and reward codes: 7 characters from an alphabet with no
 * look-alikes (no 0/O, no 1/I), shown grouped `K7M-4QX2`. The dash is display
 * only — the API takes the code with or without it, in any case, and ignores
 * spaces. Reward codes issued before the change are 8 characters (a subset of
 * the same alphabet) and still work, so typing allows 8 and only groups 7.
 */
export const CODE_ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
export const CODE_LENGTH = 7;
const LEGACY_LENGTH = 8;
const GROUP = 3;

const allowed = new Set(CODE_ALPHABET);

/** What is sent to the API: uppercase, no dashes or spaces. */
export const normalizeCode = (value) =>
  String(value ?? "")
    .toUpperCase()
    .replace(/[\s-]+/g, "");

/** `K7M4QX2` → `K7M-4QX2`; any other length is shown as it is. */
export const formatCode = (code) => {
  const bare = normalizeCode(code);
  return bare.length === CODE_LENGTH ? `${bare.slice(0, GROUP)}-${bare.slice(GROUP)}` : bare;
};

/**
 * As somebody types: uppercase, only characters a code can contain, at most
 * 8, and the dash put in after the third once there is more to show.
 */
export const formatCodeInput = (value) => {
  const bare = [...normalizeCode(value)]
    .filter((c) => allowed.has(c))
    .join("")
    .slice(0, LEGACY_LENGTH);

  if (bare.length > GROUP && bare.length <= CODE_LENGTH) {
    return `${bare.slice(0, GROUP)}-${bare.slice(GROUP)}`;
  }

  return bare;
};
